import styled from 'styled-components';

export const TextArea = styled.textarea`
   {
    width: 100%;
    min-height: 150px;
    margin: 0;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: ${p => p.theme.dividerColor} !important;
    border-radius: 5px !important;
    outline: none;
    padding: 12px 18px;
    font-size: 18px;

    &:hover {
      border-color: ${p => p.theme.terminalBg} !important;
    }

    &:focus,
    &:active {
      border-color: ${p => p.theme.primaryColor} !important;
    }
  }
`;
